import getWithToken from './base/get-with-token'

const getSettingsUrlFeedBack = getWithToken(`/list-url-feedback`)

export default getSettingsUrlFeedBack
